const AUTO_DISMISS_MS = 10_000

function removeFlashStackIfEmpty(stack) {
  if (stack?.isConnected && !stack.querySelector(".flash")) {
    stack.remove()
  }
}

function dismissFlash(flashEl) {
  if (!flashEl?.isConnected) return
  const stack = flashEl.closest(".flash-stack")
  if (flashEl._flashAutoDismissTimer) {
    clearTimeout(flashEl._flashAutoDismissTimer)
    flashEl._flashAutoDismissTimer = null
  }
  flashEl.remove()
  removeFlashStackIfEmpty(stack)
}

function bindFlash(flashEl) {
  if (flashEl.dataset.flashBound === "1") return
  flashEl.dataset.flashBound = "1"

  const closeBtn = flashEl.querySelector(".flash-dismiss")
  const onDismiss = () => dismissFlash(flashEl)

  closeBtn?.addEventListener("click", onDismiss)

  flashEl._flashAutoDismissTimer = setTimeout(onDismiss, AUTO_DISMISS_MS)
}

export function initFlashDismissals(root = document) {
  root.querySelectorAll(".flash-stack .flash").forEach(bindFlash)
}

function boot() {
  initFlashDismissals()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot)
} else {
  boot()
}
